/*
 * LyteWork Desk Plate Customizer
 * Mobile Fixes: Aspect Ratio, Fail-safe Cart, Pricing Layout
 */

class DeskPlateCustomizer {
    constructor() {
        this.config = {
            logoUrl: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/Lw_logo_04_Artboard_2_Copy_3.png?v=1732912722',

            plateColors: [
                // Row 1: Silver Engraving
                { id: 'black-silver', name: 'Black / Silver', bgColorKey: 'Black', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GInv_Black-Silver.png?v=1736619472' },
                { id: 'red-silver', name: 'Red / Silver', bgColorKey: 'Red', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_VN1J_Red-Silver.png?v=1736619486' },
                { id: 'blue-silver', name: 'Blue / Silver', bgColorKey: 'Blue', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_GhYz_Blue-Silver.png?v=1736619495' },
                { id: 'green-silver', name: 'Green / Silver', bgColorKey: 'Green', engravingColor: '#C4C4C4', cost: 0, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CXht_Green-Silver.png?v=1736619505' },
                
                // Row 2: Gold Engraving
                { id: 'black-gold', name: 'Black / Gold', bgColorKey: 'Black', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_USN2_Black-Gold.png?v=1736619513' },
                { id: 'red-gold', name: 'Red / Gold', bgColorKey: 'Red', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_ZG4L_Red-Gold.png?v=1736619522' },
                { id: 'blue-gold', name: 'Blue / Gold', bgColorKey: 'Blue', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_rxOr_Blue-Gold.png?v=1736619531' },
                { id: 'green-gold', name: 'Green / Gold', bgColorKey: 'Green', engravingColor: '#B8A35F', cost: 1.99, img: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_lhKa_Green-Gold.png?v=1736619540' }
            ],
            acrylicPlate: {
                id: 'acrylic',
                name: 'Acrylic Plate',
                bgColor: '#d9d9d9',
                engravingColor: '#f7f7f7',
                cost: 0
            },
            
            backgroundPlates: {
                Black: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_0sYk_Black_20Metal.png?v=1736619548',
                Red: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_pQJS_Red_20Metal.png?v=1736619603',
                Blue: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_CC7H_Blue_20Metal.png?v=1736619615',
                Green: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_6Fms_Green_20Metal.png?v=1736619624'
            },
            
            basePlates: {
                Gold: { 
                    url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_7osf_Gold_20Metal.png?v=1736619642',
                    cost: 3.99 
                },
                Silver: { 
                    url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/a_EbR7_Silver_20Metal.png?v=1736619633',
                    cost: 3.99 
                }
            },
            
            fonts: [
                { name: 'Arial', value: 'Arial, sans-serif' },
                { name: 'Times New Roman', value: "'Times New Roman', serif" },
                { name: 'Georgia', value: 'Georgia, serif' },
                { name: 'Copperplate', value: "'Copperplate', fantasy", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/COPRGTB.TTF?v=1751605768' },
                { name: 'Monotype Corsiva', value: "'Monotype Corsiva', cursive", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/MTCORSVA.TTF?v=1751605992' },
                { name: 'Engravers', value: "'Engravers MT', serif", url: 'https://cdn.shopify.com/s/files/1/0590/2244/2570/files/ENGR.TTF?v=1751606144' }
            ],
            
            fees: {
                logoSetup: 15.00,
                cushionedFeet: 1.99
            }
        };

        this.state = {
            product: {
                isAcrylic: false,
                variantId: null,
                basePrice: 0
            },
            style: {
                plateColor: null, 
                useBasePlate: false,
                useCushionedFeet: false
            },
            logo: {
                uploadedLogo: null,
                logoSize: 70,
                logoSetupFee: false
            },
            text: {
                line1: { id: 'line1', content: 'Recipient Name', font: "'Monotype Corsiva', cursive", size: 32, isBold: false, isItalic: false, isActive: true },
                line2: { id: 'line2', content: 'Title / Position', font: "'Times New Roman', serif", size: 20, isBold: false, isItalic: false, isActive: true }
            },
            quantity: 1,
            deskPlates: [], 
            copyPlateSettings: {
                line1: false,
                line2: false
            }
        };

        this.modal = null;
        this.init();
    }
    
    init() {
        this.loadFonts();
        this.attachTrigger();
    }
    
    loadFonts() {
        const style = document.createElement('style');
        style.textContent = this.config.fonts
            .filter(f => f.url)
            .map(f => `@font-face { font-family: '${f.name}'; src: url('${f.url}'); }`)
            .join('\n');
        document.head.appendChild(style);
    }
    
    attachTrigger() {
        const selector = '.lw-deskplate-trigger';
        const intervalTime = 50; 

        const checkForTrigger = () => {
            const trigger = document.querySelector(selector);
            if (trigger) {
                console.log('✅ Desk Plate Customizer trigger found.');
                if (!trigger.hasAttribute('data-customizer-listener-attached')) {
                    trigger.addEventListener('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.open();
                    });
                    trigger.setAttribute('data-customizer-listener-attached', 'true');
                    clearInterval(checkInterval);
                }
            }
        };

        const checkInterval = setInterval(checkForTrigger, intervalTime);
        setTimeout(() => {
            if (!document.querySelector(selector)) clearInterval(checkInterval);
        }, 10000); 
    }
    
    async open() {
        await this.fetchProductData();
        this.buildModal();
        this.attachEventListeners();
        this.setupVariantChangeListener();
        this.updatePreview();
        this.updatePrice();
        document.body.classList.add('lw-modal-open');
    }
    
    close() {
        if (this.modal) {
            this.modal.remove();
            this.modal = null;
            document.body.classList.remove('lw-modal-open');
        }
    }

    async fetchProductData(passedVariant = null) {
        try {
            const productHandleMatch = window.location.pathname.match(/\/products\/([a-z0-9-]+)/);
            if (!productHandleMatch) throw new Error("Could not find product handle in URL.");
            
            const response = await fetch(`/products/${productHandleMatch[1]}.js`);
            if (!response.ok) throw new Error(`Failed to fetch product JSON: ${response.statusText}`);
            
            const product = await response.json();
            
            let variant;
            if (passedVariant) {
                variant = passedVariant;
            } else {
                let currentVariantId = new URL(window.location).searchParams.get('variant');
                if (!currentVariantId) {
                    const formInput = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
                    if (formInput) currentVariantId = formInput.value;
                }
                variant = product.variants.find(v => v.id == currentVariantId) || product.variants[0];
            }
            
            this.state.product.isAcrylic = product.tags.includes('acrylic-desk-plate');
            
            this.state.product = {
                ...this.state.product,
                title: product.title,
                variantId: variant.id,
                variantTitle: variant.title,
                basePrice: variant.price / 100,
                featuredImage: variant.featured_image?.src || product.featured_image,
            };

            if (this.state.product.isAcrylic) {
                this.state.style.plateColor = this.config.acrylicPlate;
                this.state.style.useBasePlate = false; 
            } else {
                if (!this.state.style.plateColor || this.state.style.plateColor.id === 'acrylic') {
                     this.state.style.plateColor = this.config.plateColors[0];
                }
            }
            
        } catch (error) {
            console.error('Error fetching product:', error);
            this.state.product = {
                title: 'Desk Plate',
                basePrice: 10,
                featuredImage: '',
                isAcrylic: false,
                variantId: null
            };
            this.state.style.plateColor = this.config.plateColors[0];
        }
    }

    setupVariantChangeListener() {
        document.addEventListener('variant:change', async (e) => {
            const newVariant = e.detail.variant || e.variant;
            if (newVariant) await this.fetchProductData(newVariant); 
            else await this.fetchProductData();
            
            this.updatePrice();
            this.updatePreview();
            
            const activeTab = this.modal.querySelector('.lw-deskplate-tab.active');
            if (activeTab) this.switchTab(activeTab.dataset.tab);
        });
    }

    buildModal() {
        this.modal = document.createElement('div');
        this.modal.className = 'lw-deskplate-modal'; 
        this.modal.innerHTML = `
            <div class="lw-deskplate-overlay"></div>
            <div class="lw-deskplate-container">
                <header class="lw-deskplate-header">
                    <div class="lw-header-left">
                        <img src="${this.config.logoUrl}" alt="Logo" class="lw-header-logo">
                        <div>
                            <h2>${this.state.product.title}</h2>
                            <p>${this.state.product.variantTitle === 'Default Title' ? '' : (this.state.product.variantTitle || '')}</p>
                        </div>
                    </div>
                    <button class="lw-deskplate-close">&times;</button>
                </header>
                
                <div class="lw-deskplate-body">
                    <div class="lw-deskplate-preview-section">
                        <div class="lw-deskplate-preview-container">
                            <div class="lw-deskplate-baseplate"></div>
                            <div class="lw-deskplate-plate">
                                <div class="lw-deskplate-engraving">
                                    <div class="lw-logo-layer"></div>
                                    <div class="lw-text-layer"></div>
                                </div>
                            </div>
                            <div class="lw-cushioned-feet"></div>
                        </div>
                    </div>
                    
                    <div class="lw-deskplate-options-section">
                        <div class="lw-deskplate-tabs">
                            <button class="lw-deskplate-tab active" data-tab="plate-options">Plate Options</button>
                            <button class="lw-deskplate-tab" data-tab="logo-text">Logo & Text</button>
                            <button class="lw-deskplate-tab" data-tab="quantity">Multiples</button>
                        </div>
                        
                        <div class="lw-deskplate-tab-content">
                            ${this.renderPlateOptionsTab()}
                        </div>
                    </div>
                </div>
                
                <footer class="lw-deskplate-footer">
                    <div class="lw-deskplate-price">
                        <div class="lw-price-display-container"></div>
                    </div>
                    <button type="button" class="lw-deskplate-btn lw-deskplate-btn-primary" id="addToCartBtn">Add to Cart</button>
                </footer>
            </div>
        `;
        document.body.appendChild(this.modal);
    }

    renderPlateOptionsTab() {
        const isAcrylic = this.state.product.isAcrylic;
        return `
            <div class="lw-deskplate-tab-pane active" data-pane="plate-options">
                <h4>Plate Color</h4>
                ${isAcrylic ? '<p class="lw-help-text">Color options are disabled for acrylic plates.</p>' : ''}
                <div class="lw-color-grid">
                    ${this.config.plateColors.map(plate => {
                        const costText = plate.cost > 0 ? ` (+$${plate.cost.toFixed(2)})` : '';
                        return `
                        <div class="lw-color-option ${this.state.style.plateColor.id === plate.id ? 'active' : ''} ${isAcrylic ? 'disabled' : ''}" 
                             data-plate-id="${plate.id}">
                            <img src="${plate.img}" alt="${plate.name}" class="lw-color-thumb">
                            <span>${plate.name}${costText}</span>
                        </div>
                    `}).join('')}
                    ${isAcrylic ? `<div class="lw-color-option active disabled" data-plate-id="acrylic"><span>${this.config.acrylicPlate.name}</span></div>` : ''}
                </div>
                <h4>Options</h4>
                ${this.renderBasePlateToggle(isAcrylic)}
                <label class="lw-toggle-option">
                    <span class="lw-toggle">
                        <input type="checkbox" id="cushionedFeetToggle" ${this.state.style.useCushionedFeet ? 'checked' : ''}>
                        <span class="lw-toggle-slider"></span>
                    </span>
                    <span>Add 4 Cushioned Feet (+$${this.config.fees.cushionedFeet.toFixed(2)})</span>
                </label>
            </div>
        `;
    }

    renderBasePlateToggle(isDisabled = false) {
        return `
        <label class="lw-toggle-option ${isDisabled ? 'disabled' : ''}">
            <span class="lw-toggle">
                <input type="checkbox" id="basePlateToggle" ${this.state.style.useBasePlate ? 'checked' : ''} ${isDisabled ? 'disabled' : ''}>
                <span class="lw-toggle-slider"></span>
            </span>
            <span>Add Base Plate (+$${this.config.basePlates.Gold.cost.toFixed(2)})${isDisabled ? ' - N/A for Acrylic' : ''}</span>
        </label>
        `;
    }

    renderLogoTextTab() {
        return `
            <div class="lw-deskplate-tab-pane" data-pane="logo-text">
                <h4>Logo (Left Side)</h4>
                ${this.renderLogoUpload()}
                
                <h4 style="margin-top: 30px; border-top: 1px solid #eee; padding-top: 30px;">
                    Text (Right Side)
                </h4>
                <p class="lw-help-text">Add up to 2 lines of text.</p>
                
                ${this.renderTextLineField(this.state.text.line1, 'Line 1 (Name)')}
                
                ${this.state.text.line2.isActive ? 
                    `
                    ${this.renderTextLineField(this.state.text.line2, 'Line 2 (Title)')}
                    <div style="text-align: right;">
                        <button class="lw-text-action-btn remove" id="removeLine2Btn">Remove Line 2</button>
                    </div>
                    ` 
                    : 
                    `
                    <div class="lw-add-line-wrapper">
                         <button class="lw-text-action-btn add" id="addLine2Btn">+ Add Line 2 (Title)</button>
                    </div>
                    `
                }
            </div>
        `;
    }

    renderLogoUpload() {
        return `
        <div class="lw-logo-upload">
            <div class="lw-upload-area ${this.state.logo.uploadedLogo ? 'has-file' : ''}" id="logoUploadArea">
                ${this.state.logo.uploadedLogo ?
                `<div>
                    <img src="${this.state.logo.uploadedLogo}" alt="Logo" style="max-width: ${this.state.logo.logoSize || 70}%; max-height: ${this.state.logo.logoSize || 70}%;">
                    <button class="lw-remove-logo-btn">&times; Remove</button>
                 </div>` :
                    `<div class="lw-upload-prompt">
                        <span></span>
                        <span>Click to upload logo</span>
                     </div>`
                }
            </div>
            <input type="file" id="logoFileInput" accept="image/*" style="display: none;">
            ${this.state.logo.uploadedLogo ? `
                <div class="lw-logo-controls">
                    <label>Logo Size</label>
                    <div class="lw-logo-size-slider">
                        <input type="range" id="logoSizeSlider" min="30" max="90" value="${this.state.logo.logoSize || 70}" step="5">
                         <span id="logoSizeValue">${this.state.logo.logoSize || 70}%</span>
                    </div>
                </div>` : ''}
        </div>`;
    }

    renderTextLineField(line, label) {
        return `
            <div class="lw-text-field" data-line-id="${line.id}">
                <div class="lw-field-header">
                    <label>${label}</label>
                    <div class="lw-field-controls">
                        <select class="lw-font-select" data-field="${line.id}">
                            ${this.config.fonts.map(font => 
                                `<option value="${font.value}" ${line.font === font.value ? 'selected' : ''}>${font.name}</option>`
                            ).join('')}
                        </select>
                        <div class="lw-size-control">
                            <button class="lw-size-btn" data-field="${line.id}" data-delta="-1">-</button>
                            <span>${line.size}px</span>
                            <button class="lw-size-btn" data-field="${line.id}" data-delta="1">+</button>
                        </div>
                        <div class="lw-style-controls">
                            <button class="lw-style-btn ${line.isBold ? 'active' : ''}" data-field="${line.id}" data-style="isBold"><b>B</b></button>
                            <button class="lw-style-btn ${line.isItalic ? 'active' : ''}" data-field="${line.id}" data-style="isItalic"><i>I</i></button>
                        </div>
                    </div>
                </div>
                <input type="text" class="lw-text-input" data-field="${line.id}" value="${line.content}">
            </div>
        `;
    }
    
    renderQuantityTab() {
        this.syncPlatesArray();
        return `
        <div class="lw-deskplate-tab-pane" data-pane="quantity">
            <h4>Quantity</h4>
            <p class="lw-help-text">How many desk plates would you like to order?</p>

            <div class="lw-quantity-control">
                <button class="lw-qty-btn" data-action="decrease"></button>
                <input type="number" class="lw-qty-input" value="${this.state.quantity}" min="1" max="100">
                <button class="lw-qty-btn" data-action="increase">+</button>
            </div>

            ${this.state.quantity > 1 ? `
                <div class="lw-plates-section">
                    <h4>Engraving Details</h4>
                    <div class="lw-copy-settings">
                        <h5>Copy to All Plates:</h5>
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="line1" ${this.state.copyPlateSettings.line1 ? 'checked' : ''}>
                            <span>Line 1</span>
                        </label>
                        ${this.state.text.line2.isActive ? `
                        <label class="lw-copy-checkbox">
                            <input type="checkbox" data-copy-field="line2" ${this.state.copyPlateSettings.line2 ? 'checked' : ''}>
                            <span>Line 2</span>
                        </label>` : ''}
                    </div>
                    <div class="lw-plates-table-wrapper">
                        <table class="lw-plates-table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Line 1</th>
                                    ${this.state.text.line2.isActive ? '<th>Line 2</th>' : ''}
                                </tr>
                            </thead>
                            <tbody>${this.renderPlatesTableRows()}</tbody>
                        </table>
                    </div>
                </div>
            ` : ''}
            <div class="lw-price-breakdown">${this.renderPriceBreakdown()}</div>
        </div>
        `;
    }
    
    syncPlatesArray() {
        const defaultLine1 = this.state.text.line1.content;
        const defaultLine2 = this.state.text.line2.isActive ? this.state.text.line2.content : '';

        if (this.state.deskPlates.length > this.state.quantity) {
            this.state.deskPlates = this.state.deskPlates.slice(0, this.state.quantity);
        } else {
            while (this.state.deskPlates.length < this.state.quantity) {
                if (this.state.deskPlates.length === 0) {
                    this.state.deskPlates.push({
                        line1: defaultLine1,
                        line2: defaultLine2
                    });
                } else {
                    this.state.deskPlates.push({
                        line1: this.state.copyPlateSettings.line1 ? this.state.deskPlates[0].line1 : defaultLine1,
                        line2: this.state.copyPlateSettings.line2 ? this.state.deskPlates[0].line2 : defaultLine2
                    });
                }
            }
        }
    }

    renderPlatesTableRows() {
        return this.state.deskPlates.map((plate, index) => {
            const isCopied = (field) => index > 0 && this.state.copyPlateSettings[field];
            return `
            <tr data-row-index="${index}">
                <td class="row-number">${index + 1}</td>
                <td>
                    <input type="text" class="lw-table-input" 
                           data-plate-index="${index}" data-field="line1"
                           value="${plate.line1}" placeholder="Name"
                           ${isCopied('line1') ? 'readonly' : ''}>
                </td>
                ${this.state.text.line2.isActive ? `
                <td>
                    <input type="text" class="lw-table-input" 
                           data-plate-index="${index}" data-field="line2"
                           value="${plate.line2}" placeholder="Title"
                           ${isCopied('line2') ? 'readonly' : ''}>
                </td>` : ''}
            </tr>
            `;
        }).join('');
    }

    attachEventListeners() {
        this.modal.querySelector('.lw-deskplate-close').addEventListener('click', () => this.close());
        this.modal.querySelector('.lw-deskplate-overlay').addEventListener('click', () => this.close());
        this.modal.querySelectorAll('.lw-deskplate-tab').forEach(tab => {
            tab.addEventListener('click', () => this.switchTab(tab.dataset.tab));
        });
        this.attachPlateOptionsEvents();
        this.modal.querySelector('#addToCartBtn').addEventListener('click', (e) => {
            e.preventDefault();
            this.addToCart();
        });
    }

    attachPlateOptionsEvents() {
        this.modal.querySelectorAll('[data-plate-id]').forEach(el => {
            el.addEventListener('click', () => {
                if (this.state.product.isAcrylic) return; 
                const plateId = el.dataset.plateId;
                this.state.style.plateColor = this.config.plateColors.find(c => c.id === plateId);
                this.modal.querySelectorAll('[data-plate-id]').forEach(e => e.classList.remove('active'));
                el.classList.add('active');
                this.updatePreview();
                this.updatePrice();
            });
        });
        const basePlateToggle = this.modal.querySelector('#basePlateToggle');
        if (basePlateToggle) {
            basePlateToggle.addEventListener('change', (e) => {
                this.state.style.useBasePlate = e.target.checked;
                this.updatePreview();
                this.updatePrice();
            });
        }
        const feetToggle = this.modal.querySelector('#cushionedFeetToggle');
        if (feetToggle) {
            feetToggle.addEventListener('change', (e) => {
                this.state.style.useCushionedFeet = e.target.checked;
                this.updatePreview();
                this.updatePrice();
            });
        }
    }
    
    attachLogoTextEvents() {
        const uploadArea = this.modal.querySelector('#logoUploadArea');
        const fileInput = this.modal.querySelector('#logoFileInput');
        if (uploadArea) {
            uploadArea.addEventListener('click', (e) => {
                if (e.target.classList.contains('lw-remove-logo-btn')) return;
                fileInput.click();
            });
        }
        const removeLogoBtn = this.modal.querySelector('.lw-remove-logo-btn');
        if (removeLogoBtn) {
            removeLogoBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.state.logo.uploadedLogo = null;
                this.switchTab('logo-text'); 
                this.updatePreview();
            });
        }
        if (fileInput) {
            fileInput.addEventListener('change', (e) => {
                const file = e.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.state.logo.uploadedLogo = e.target.result;
                        this.switchTab('logo-text'); 
                        this.updatePreview();
                    };
                    reader.readAsDataURL(file);
                }
            });
        }
        const sizeSlider = this.modal.querySelector('#logoSizeSlider');
        if (sizeSlider) {
            sizeSlider.addEventListener('input', (e) => {
                this.state.logo.logoSize = parseInt(e.target.value);
                this.modal.querySelector('#logoSizeValue').textContent = `${e.target.value}%`;
                this.updatePreview();
            });
        }
        const removeLine2Btn = this.modal.querySelector('#removeLine2Btn');
        if (removeLine2Btn) {
            removeLine2Btn.addEventListener('click', () => {
                this.state.text.line2.isActive = false;
                this.state.text.line2.content = ''; 
                this.switchTab('logo-text');
                this.updatePreview();
            });
        }
        const addLine2Btn = this.modal.querySelector('#addLine2Btn');
        if (addLine2Btn) {
            addLine2Btn.addEventListener('click', () => {
                this.state.text.line2.isActive = true;
                this.state.text.line2.content = 'Title / Position'; 
                this.switchTab('logo-text');
                this.updatePreview();
            });
        }
        this.modal.querySelectorAll('.lw-text-field[data-line-id]').forEach(lineRow => {
            const lineId = lineRow.dataset.lineId; 
            const line = this.state.text[lineId];
            if (!line) return;
            lineRow.querySelector('.lw-text-input').addEventListener('input', (e) => {
                line.content = e.target.value;
                this.updatePreview();
                if (this.state.deskPlates[0]) this.state.deskPlates[0][lineId] = e.target.value;
            });
            lineRow.querySelector('.lw-font-select').addEventListener('change', (e) => {
                line.font = e.target.value;
                this.updatePreview();
            });
            lineRow.querySelectorAll('.lw-size-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const delta = parseInt(btn.dataset.delta);
                    line.size = Math.max(8, Math.min(48, line.size + delta));
                    lineRow.querySelector('.lw-size-control span').textContent = `${line.size}px`;
                    this.updatePreview();
                });
            });
            lineRow.querySelectorAll('.lw-style-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();
                    const style = btn.dataset.style; 
                    line[style] = !line[style];
                    btn.classList.toggle('active', line[style]);
                    this.updatePreview();
                });
            });
        });
    }
    
    attachQuantityEvents() {
        const qtyInput = this.modal.querySelector('.lw-qty-input');
        const syncTableToState = () => {
            this.syncPlatesArray(); 
            this.switchTab('quantity');
            this.updatePrice();
        };
        this.modal.querySelectorAll('.lw-qty-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const current = parseInt(qtyInput.value);
                let newVal = (btn.dataset.action === 'increase') ? Math.min(100, current + 1) : Math.max(1, current - 1);
                qtyInput.value = newVal;
                this.state.quantity = newVal;
                syncTableToState(); 
            });
        });
        if (qtyInput) {
            qtyInput.addEventListener('change', (e) => {
                let val = parseInt(e.target.value) || 1;
                val = Math.max(1, Math.min(100, val));
                e.target.value = val;
                this.state.quantity = val;
                syncTableToState(); 
            });
        }
        this.attachTableInputListeners(this.modal.querySelectorAll('.lw-table-input'));
        this.modal.querySelectorAll('.lw-copy-checkbox input').forEach(cb => {
            cb.addEventListener('change', (e) => {
                const field = e.target.dataset.copyField;
                this.state.copyPlateSettings[field] = e.target.checked;
                const sourceValue = this.state.deskPlates[0] ? this.state.deskPlates[0][field] : '';
                this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(input => {
                    const index = parseInt(input.dataset.plateIndex);
                    if (index > 0) {
                        if (this.state.copyPlateSettings[field]) {
                            input.value = sourceValue;
                            this.state.deskPlates[index][field] = sourceValue; 
                            input.readOnly = true;
                        } else input.readOnly = false;
                    }
                });
            });
        });
    }

    attachTableInputListeners(inputs) {
        inputs.forEach(input => {
            const newInput = input.cloneNode(true);
            input.parentNode.replaceChild(newInput, input);
            newInput.addEventListener('input', (e) => {
                const index = parseInt(e.target.dataset.plateIndex);
                const field = e.target.dataset.field;
                const newValue = e.target.value;
                if (this.state.deskPlates[index]) this.state.deskPlates[index][field] = newValue;
                if (index === 0) this.state.text[field].content = newValue;
                if (index === 0 && this.state.copyPlateSettings[field]) {
                    for (let i = 1; i < this.state.quantity; i++) {
                        if (this.state.deskPlates[i]) this.state.deskPlates[i][field] = newValue;
                    }
                    this.modal.querySelectorAll(`.lw-table-input[data-field="${field}"]`).forEach(inputField => {
                        const inputIndex = parseInt(inputField.dataset.plateIndex);
                        if (inputIndex > 0) inputField.value = newValue;
                    });
                }
            });
        });
    }

    switchTab(tabName) {
        this.modal.querySelectorAll('.lw-deskplate-tab').forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === tabName);
        });
        const contentArea = this.modal.querySelector('.lw-deskplate-tab-content');
        switch (tabName) {
            case 'plate-options':
                contentArea.innerHTML = this.renderPlateOptionsTab();
                this.attachPlateOptionsEvents();
                break;
            case 'logo-text':
                contentArea.innerHTML = this.renderLogoTextTab();
                this.attachLogoTextEvents();
                break;
            case 'quantity':
                contentArea.innerHTML = this.renderQuantityTab();
                this.attachQuantityEvents();
                break;
        }
    }

    updatePreview() {
        const basePlate = this.modal.querySelector('.lw-deskplate-baseplate');
        const plate = this.modal.querySelector('.lw-deskplate-plate');
        const logoLayer = this.modal.querySelector('.lw-logo-layer');
        const textLayer = this.modal.querySelector('.lw-text-layer');
        const plateConfig = this.state.style.plateColor;
        
        if (this.state.product.isAcrylic) {
            plate.style.backgroundImage = 'none';
            plate.style.backgroundColor = plateConfig.bgColor;
        } else {
            plate.style.backgroundColor = 'none';
            plate.style.backgroundImage = `url('${this.config.backgroundPlates[plateConfig.bgColorKey]}')`;
        }
        
        if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
            let basePlateUrl = (plateConfig.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
            basePlate.style.backgroundImage = `url('${basePlateUrl}')`;
            basePlate.style.setProperty('display', 'block', 'important');
        } else {
            basePlate.style.setProperty('display', 'none', 'important');
        }
        
        this.updateLogoLayer(logoLayer);
        this.updateTextLayer(textLayer);
        this.updateCushionedFeet();
    }
    
    updateLogoLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.plateColor.engravingColor;
        layer.parentElement.classList.toggle('has-logo', !!this.state.logo.uploadedLogo);
        if (this.state.logo.uploadedLogo) {
            const img = document.createElement('img');
            img.src = this.state.logo.uploadedLogo;
            img.className = 'lw-uploaded-logo';
            img.style.maxWidth = `${this.state.logo.logoSize}%`;
            img.style.maxHeight = `${this.state.logo.logoSize}%`;
            img.style.filter = this.getSVGFilter(engravingColor);
            layer.appendChild(img);
        }
    }

    updateTextLayer(layer) {
        layer.innerHTML = '';
        const engravingColor = this.state.style.plateColor.engravingColor;
        [this.state.text.line1, this.state.text.line2].forEach(line => {
            if (line.content && (line.id === 'line1' || line.isActive)) {
                const div = document.createElement('div');
                div.className = `lw-deskplate-text-line`;
                div.style.fontFamily = line.font;
                div.style.fontSize = `${line.size}px`;
                div.style.color = engravingColor;
                div.style.fontWeight = line.isBold ? 'bold' : 'normal';
                div.style.fontStyle = line.isItalic ? 'italic' : 'normal';
                div.textContent = line.content;
                layer.appendChild(div);
            }
        });
    }

    updateCushionedFeet() {
        const plate = this.modal.querySelector('.lw-deskplate-preview-container'); 
        let feetLayer = plate.querySelector('.lw-cushioned-feet');
        
        if (this.state.style.useCushionedFeet) {
            if (!feetLayer) {
                feetLayer = document.createElement('div');
                feetLayer.className = 'lw-cushioned-feet';
                feetLayer.style.cssText = 'position: absolute; inset: 0; z-index: 10;';
                plate.appendChild(feetLayer);
            }
            feetLayer.innerHTML = '';
            ['bottom-left', 'bottom-right'].forEach(pos => {
                const foot = document.createElement('div');
                foot.className = `lw-foot lw-foot-${pos}`;
                foot.style.cssText = `
                    position: absolute;
                    width: 12px;
                    height: 12px;
                    background-color: #333;
                    border-radius: 50%;
                    box-shadow: inset 0 0 2px rgba(0,0,0,0.5);
                `;
                if (pos.includes('bottom')) foot.style.bottom = '-6px'; 
                if (pos.includes('left')) foot.style.left = '15px';
                if (pos.includes('right')) foot.style.right = '15px';
                feetLayer.appendChild(foot);
            });
        } else if (feetLayer) feetLayer.remove();
    }
    
    getSVGFilter(color) {
        if (color === '#C4C4C4') { // Silver
            return 'brightness(0) saturate(100%) invert(79%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(98%) contrast(88%)';
        } else if (color === '#B8A35F') { // Gold
            return 'brightness(0) saturate(100%) invert(72%) sepia(15%) saturate(1149%) hue-rotate(2deg) brightness(91%) contrast(87%)';
        } else if (color === '#000000') { // Black
            return 'brightness(0) saturate(100%) invert(0%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(0%) contrast(100%)';
        } else if (color === '#f7f7f7') { // White
             return 'brightness(0) saturate(100%) invert(100%) sepia(0%) saturate(14%) hue-rotate(242deg) brightness(104%) contrast(95%)';
        }
        return '';
    }

    renderPriceBreakdown() {
        const perPlaqueSurcharges = (this.state.style.plateColor.cost || 0) +
                                    (this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0) +
                                    (this.state.style.useCushionedFeet ? this.config.fees.cushionedFeet : 0);
        
        const perPlaquePrice = (this.state.product.basePrice || 0) + perPlaqueSurcharges;
        const total = (perPlaquePrice * this.state.quantity);

        let breakdown = `<div class="lw-price-line"><span>Base Plate (${this.state.product.variantTitle === 'Default Title' ? 'Desk Plate' : this.state.product.variantTitle}):</span><span>$${(this.state.product.basePrice || 0).toFixed(2)}</span></div>`;
        if (this.state.style.plateColor.cost > 0) breakdown += `<div class="lw-price-line"><span>Plate Color Add-on:</span><span>$${this.state.style.plateColor.cost.toFixed(2)}</span></div>`;
        if (this.state.style.useBasePlate && !this.state.product.isAcrylic) breakdown += `<div class="lw-price-line"><span>Base Plate Add-on:</span><span>$${this.config.basePlates.Gold.cost.toFixed(2)}</span></div>`;
        if (this.state.style.useCushionedFeet) breakdown += `<div class="lw-price-line"><span>Cushioned Feet:</span><span>$${this.config.fees.cushionedFeet.toFixed(2)}</span></div>`;
        breakdown += `<div class="lw-price-line subtotal"><span>Price Per Plaque:</span><span>$${perPlaquePrice.toFixed(2)}</span></div>`;
        breakdown += `<div class="lw-price-line"><span>Quantity:</span><span>&times; ${this.state.quantity}</span></div>`;
        breakdown += `<div class="lw-price-line total"><span>Total:</span><span>$${total.toFixed(2)}</span></div>`;
        return breakdown;
    }
    
    calculateTotalPrice() {
        const perPlaqueSurcharges = (this.state.style.plateColor.cost || 0) + (this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0) + (this.state.style.useCushionedFeet ? this.config.fees.cushionedFeet : 0);
        return ((this.state.product.basePrice || 0) + perPlaqueSurcharges) * this.state.quantity;
    }
    
    calculatePerItemPrice() {
        const perPlaqueSurcharges = (this.state.style.plateColor.cost || 0) + (this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0) + (this.state.style.useCushionedFeet ? this.config.fees.cushionedFeet : 0);
        return (this.state.product.basePrice || 0) + perPlaqueSurcharges;
    }
    
    updatePrice() {
        const container = this.modal.querySelector('.lw-price-display-container');
        if (container) {
            const perItem = this.calculatePerItemPrice();
            const total = this.calculateTotalPrice();
            container.innerHTML = `
                <div class="lw-price-display-row">
                    <span>Per: $${perItem.toFixed(2)}</span>
                    <span class="lw-price-divider">|</span>
                    <span>Qty: ${this.state.quantity}</span>
                </div>
                <div class="lw-price-display-total">
                    Total: $${total.toFixed(2)}
                </div>
            `;
        }
        const breakdownEl = this.modal.querySelector('.lw-price-breakdown');
        if (breakdownEl && this.modal.querySelector('[data-tab="quantity"].active')) {
            breakdownEl.innerHTML = this.renderPriceBreakdown();
        }
    }
    
    async generatePreviewImage() {
        if (typeof html2canvas === 'undefined') return null;
        const previewContainer = this.modal.querySelector('.lw-deskplate-preview-container');
        if (!previewContainer) return null;
        
        // Hide feet for capture
        const feet = previewContainer.querySelector('.lw-cushioned-feet');
        if(feet) feet.style.display = 'none';
        
        const logoImg = previewContainer.querySelector('.lw-uploaded-logo');
        let originalLogoSrc = null;

        // TIMEOUT WRAPPER
        const generateWithTimeout = async () => {
            const imagesToPreload = [];
            if (!this.state.product.isAcrylic) {
                const plateConfig = this.state.style.plateColor;
                if (plateConfig && this.config.backgroundPlates[plateConfig.bgColorKey]) imagesToPreload.push(this.config.backgroundPlates[plateConfig.bgColorKey]);
            }
            if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
                 let url = (this.state.style.plateColor.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
                 imagesToPreload.push(url);
            }

            await Promise.all(imagesToPreload.map(url => new Promise(resolve => {
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = url;
                img.onload = resolve;
                img.onerror = resolve;
            })));
            
            if (logoImg) {
                originalLogoSrc = logoImg.src;
                const engravingColor = this.state.style.plateColor.engravingColor;
                const coloredSrc = await convertImageToColoredVersion(logoImg, engravingColor);
                logoImg.src = coloredSrc;
                logoImg.style.filter = 'none';
                await new Promise(resolve => setTimeout(resolve, 50));
            }

            const basePlateElement = previewContainer.querySelector('.lw-deskplate-baseplate');
            if (this.state.style.useBasePlate && !this.state.product.isAcrylic && basePlateElement) {
                let basePlateUrl = (this.state.style.plateColor.engravingColor === '#B8A35F') ? this.config.basePlates.Gold.url : this.config.basePlates.Silver.url;
                basePlateElement.style.cssText = `display: block !important; background-image: url('${basePlateUrl}') !important; background-size: cover !important; background-position: center !important; position: absolute !important; width: 106.25% !important; height: 125% !important; top: -12.5% !important; left: -3.125% !important; z-index: 1 !important;`;
                basePlateElement.offsetHeight; 
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            
            let captureX = 0, captureY = 0;
            let captureWidth = previewContainer.scrollWidth;
            let captureHeight = previewContainer.scrollHeight;

            if (this.state.style.useBasePlate && !this.state.product.isAcrylic) {
                const extraWidth = captureWidth * 0.0625;
                const extraHeight = captureHeight * 0.25; 
                captureX = -extraWidth / 2;
                captureY = -extraHeight / 2;
                captureWidth += extraWidth;
                captureHeight += extraHeight;
            }

            const isMobile = window.innerWidth < 768;
            const scale = isMobile ? 0.4 : 0.5; 

            const plateCanvas = await html2canvas(previewContainer, {
                backgroundColor: null, 
                scale: scale,
                logging: false,
                allowTaint: true,
                useCORS: true,
                x: captureX, y: captureY, width: captureWidth, height: captureHeight,
                ignoreElements: (element) => element.tagName === 'PREDICTIVE-SEARCH'
            });
            
            const variantImg = new Image();
            variantImg.crossOrigin = "anonymous";
            variantImg.src = this.state.product.featuredImage;
            await new Promise((resolve, reject) => {
                variantImg.onload = resolve;
                variantImg.onerror = resolve;
            });
            
            const finalCanvas = document.createElement('canvas');
            const ctx = finalCanvas.getContext('2d');
            const plateWidth = plateCanvas.width;
            const plateHeight = plateCanvas.height;
            const variantScale = plateWidth / variantImg.width;
            const variantHeight = variantImg.height * variantScale;

            finalCanvas.width = plateWidth;
            finalCanvas.height = plateHeight + variantHeight;

            ctx.fillStyle = '#FFFFFF';
            ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);
            ctx.drawImage(plateCanvas, 0, 0);
            ctx.drawImage(variantImg, 0, plateHeight, plateWidth, variantHeight);
            
            return finalCanvas.toDataURL('image/jpeg', 0.85);
        };

        try {
            const result = await Promise.race([
                generateWithTimeout(),
                new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), 2500))
            ]);
            if(feet) feet.style.display = ''; // Restore feet
            // Restore logo
            if (logoImg && originalLogoSrc) {
                logoImg.src = originalLogoSrc;
                logoImg.style.filter = this.getSVGFilter(this.state.style.plateColor.engravingColor);
            }
            return result;
        } catch (e) {
            if(feet) feet.style.display = '';
            if (logoImg && originalLogoSrc) {
                logoImg.src = originalLogoSrc;
                logoImg.style.filter = this.getSVGFilter(this.state.style.plateColor.engravingColor);
            }
            return null;
        }
    }

    async addToCart() {
        if (!confirm(`You are adding ${this.state.quantity} custom desk plate(s) to your cart. Proceed?`)) return;

        const btn = this.modal.querySelector('#addToCartBtn');
        btn.disabled = true;
        btn.textContent = 'Adding...';
        
        try {
            try {
                await ensureHtml2CanvasLoaded();
            } catch (error) { }

            btn.textContent = 'Generating Preview...';
            let previewImage = null;
            try {
                previewImage = await this.generatePreviewImage();
            } catch(e) {}
            
            btn.textContent = 'Adding...';
            
            const properties = {
                '_Program': 'DeskPlateCustomizer v1.0',
                'Plate Color': this.state.style.plateColor.name,
                'Base Plate': this.state.style.useBasePlate && !this.state.product.isAcrylic ?
                    `Yes (+$${this.config.basePlates.Gold.cost.toFixed(2)})` : 'No',
                'Cushioned Feet': this.state.style.useCushionedFeet ?
                    `Yes (+$${this.config.fees.cushionedFeet.toFixed(2)})` : 'No'
            };

            properties['Logo'] = this.state.logo.uploadedLogo ? 'Uploaded Logo' : 'None';
            
            if (previewImage) properties['_preview'] = previewImage;
            
            this.syncPlatesArray();

            if (this.state.quantity === 1) {
                properties[`Line 1 (Name)`] = this.state.deskPlates[0].line1 || 'n/a';
                properties[`Line 2 (Title)`] = this.state.text.line2.isActive ? (this.state.deskPlates[0].line2 || 'n/a') : 'n/a';
            } else {
                properties['Plates'] = `${this.state.quantity} Total`;
                this.state.deskPlates.forEach((plate, index) => {
                    properties[`Plate ${index + 1} - Line 1`] = plate.line1 || 'n/a';
                    properties[`Plate ${index + 1} - Line 2`] = this.state.text.line2.isActive ? (plate.line2 || 'n/a') : 'n/a';
                });
            }
            
            // Specs properties
            ['line1', 'line2'].forEach(l => {
                const lineData = this.state.text[l];
                if ((l === 'line1' || lineData.isActive)) {
                    const fontName = lineData.font.split(',')[0].replace(/['"]/g, '');
                    let styleStr = `${fontName}, ${lineData.size}px`;
                    if (lineData.isBold) styleStr += ', Bold';
                    if (lineData.isItalic) styleStr += ', Italic';
                    properties[`${l.replace('line', 'Line ')} Specs`] = styleStr;
                }
            });

            const plateColorCost = this.state.style.plateColor.cost || 0;
            const basePlateCost = this.state.style.useBasePlate && !this.state.product.isAcrylic ? this.config.basePlates.Gold.cost : 0;
            const feetCost = this.state.style.useCushionedFeet ? this.config.fees.cushionedFeet : 0;
            const perItemSurchargeDollars = plateColorCost + basePlateCost + feetCost;
            const totalSurchargeInCents = Math.round((perItemSurchargeDollars * this.state.quantity) * 100);

            if (totalSurchargeInCents > 0) {
                properties['_addon_price'] = totalSurchargeInCents.toString();
                const breakdown = [];
                if (plateColorCost) breakdown.push(`Color: $${plateColorCost.toFixed(2)}`);
                if (basePlateCost) breakdown.push(`Base Plate: $${basePlateCost.toFixed(2)}`);
                if (feetCost) breakdown.push(`Cushioned Feet: $${feetCost.toFixed(2)}`);
                properties['_surcharge_breakdown'] = breakdown.join(', ');
            }

            const finalVariantId = this.state.product.variantId;
            if (!finalVariantId) throw new Error("Could not determine Variant ID. Add to cart failed.");

            const formData = new FormData();
            formData.append('id', finalVariantId);
            formData.append('quantity', this.state.quantity);
            Object.entries(properties).forEach(([key, value]) => {
                formData.append(`properties[${key}]`, value);
            });
            
            const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
            
            if (response.ok) {
                this.close();
                sessionStorage.setItem('openCartDrawer', 'true');
                window.location.href = '/cart';
            } else {
                throw new Error('Failed to add to cart');
            }
            
        } catch (error) {
            console.error('Cart error:', error);
            alert('Failed to add to cart. Please try again.');
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
        }
    }

} 

let html2canvasLoaded = false;
let html2canvasPromise = null;
function ensureHtml2CanvasLoaded() {
    if (html2canvasLoaded) return Promise.resolve();
    if (html2canvasPromise) return html2canvasPromise;
    html2canvasPromise = new Promise((resolve, reject) => {
        if (typeof html2canvas !== 'undefined') { html2canvasLoaded = true; resolve(); return; }
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
        script.onload = () => { html2canvasLoaded = true; resolve(); };
        script.onerror = () => reject(new Error('Failed to load html2canvas'));
        document.head.appendChild(script);
    });
    return html2canvasPromise;
}

async function convertImageToColoredVersion(imgElement, hexColor) {
    return new Promise((resolve, reject) => {
        try {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const sourceImg = new Image();
            sourceImg.crossOrigin = 'anonymous';
            sourceImg.onload = function() {
                canvas.width = sourceImg.naturalWidth;
                canvas.height = sourceImg.naturalHeight;
                ctx.drawImage(sourceImg, 0, 0);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const data = imageData.data;
                const r = parseInt(hexColor.slice(1, 3), 16);
                const g = parseInt(hexColor.slice(3, 5), 16);
                const b = parseInt(hexColor.slice(5, 7), 16);
                for (let i = 0; i < data.length; i += 4) {
                    const alpha = data[i + 3];
                    if (alpha > 0) {
                        const intensity = data[i] / 255; 
                        if (intensity < 0.95) { 
                            data[i] = r; data[i + 1] = g; data[i + 2] = b; data[i + 3] = alpha * (1 - intensity);
                        }
                    }
                }
                ctx.putImageData(imageData, 0, 0);
                resolve(canvas.toDataURL('image/png'));
            };
            sourceImg.onerror = () => reject(new Error('Image load failed'));
            let src = imgElement.src;
            if (src.startsWith('https://cdn.shopify.com/') && !src.includes('crossorigin=anonymous')) {
                 src = src.includes('?') ? `${src}&crossorigin=anonymous` : `${src}?crossorigin=anonymous`;
            }
            sourceImg.src = src;
        } catch (error) { reject(error); }
    });
}

window.customizerInstance = null; 
function initializeDeskPlateCustomizer() {
    console.log('🚀 Desk Plate Script: Initializing...'); 
    const oldModal = document.querySelector('.lw-deskplate-modal');
    if (oldModal) { oldModal.remove(); document.body.classList.remove('lw-modal-open'); }
    window.customizerInstance = new DeskPlateCustomizer();
    console.log('✅ Desk Plate Customizer is ready!');
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeDeskPlateCustomizer);
else initializeDeskPlateCustomizer();

window.addEventListener('pageshow', (event) => {
    if (event.persisted) initializeDeskPlateCustomizer();
});